const isObjectEmpty = (o, excludedField) => {
  if (!o) return true
  if (!excludedField) {
    excludedField = []
  }
  const entries = Object.entries(o)
  for (let [key, elt] of entries) {
    if (elt !== null && typeof elt === 'object') {
      if (!isObjectEmpty(elt)) {
        return false
      }
    } else if (elt !== null && elt !== '' && !excludedField.includes(key)) {
      return false
    }
  }
  return true
}

export { isObjectEmpty }
